<ul id="sale-contract-tabs" class="nav nav-tabs">
    <li class="nav-item">
        <a href="#" id="sale-summary-link" class="nav-link active" (click)="setActiveTab($event, 'sale-summary')">Summary</a>
    </li>
    <li class="nav-item">
        <a href="#" id="sale-downs-deposits-link" class="nav-link" (click)="setActiveTab($event, 'sale-downs-deposits')">
            <span>Down Payments</span>
            @if (down > 0) {
                <span class="material-icons text-success">circle</span>
            }
        </a>
    </li>
    <li class="nav-item">
        <a href="#" id="sale-products-link" class="nav-link" (click)="setActiveTab($event, 'sale-products')">
            <span>Products</span>
            @if (products > 0) {
                <span class="material-icons text-success">circle</span>
            }
        </a>        
    </li>
    <li class="nav-item">
        <a href="#" id="sale-accessories-link" class="nav-link" (click)="setActiveTab($event, 'sale-accessories')">
            <span>Accessories</span>
            @if (accessories > 0) {
                <span class="material-icons text-success">circle</span>
            }
        </a>
    </li>
    <li class="nav-item">
        <a href="#" id="sale-ttl-link" class="nav-link" (click)="setActiveTab($event, 'sale-ttl')">
            <span>Tax, Title &amp; License</span>
            @if (ttl > 0) {
                <span class="material-icons text-success">circle</span>
            }
        </a>
    </li>
</ul>

<div id="sale-contract-tab-content" class="tab-content">
    <section class="tab-pane fade active show" id="sale-summary-tab">
        <div class="card">
            <div class="card-body">
                <ul id="snapshot-items">
                    <li>
                        <label for="baseSalePrice">Base Sale Price</label>
                        <form [formGroup]="form">
                            <div class="form-group">
                                <currency-input [id]="'baseSalePrice'" [control]="form.get('baseSalePrice')" (committed)="changed($event)" (blurred)="changed($event)"></currency-input>
                            </div>
                        </form>
                    </li>
                    <li class="clickable" (click)="setActiveTab($event, 'sale-accessories')">
                        <p>PLUS: Accessories</p>
                        <p class="text-right" title="Total of all sale accessories">{{accessories | currency}}</p>
                    </li>
                    @if (!wholesale) {
                        <li class="less">
                            <p>LESS: Trade Allowance</p>
                            <p class="text-right" title="Total of all trade in allowances">{{allowance | currency}}</p>
                        </li>
                    }
                    <li class="total">
                        <p>Total Sale Price</p>
                        <p class="text-right" title="Base Sale Price + Sum of Accessory Price">{{totalSalePrice | currency}}</p>
                    </li>
                    <li class="clickable" (click)="setActiveTab($event, 'sale-ttl')">
                        <p>PLUS: Tax, Title &amp; License Fees</p>
                        <p class="text-right" title="Total of all title and license fees">{{ttl | currency}}</p>
                    </li>
                    <li class="clickable" (click)="setActiveTab($event, 'sale-products')">
                        <p>PLUS: Products</p>
                        <p class="text-right" title="Total of all product fees">{{products | currency}}</p>
                    </li>
                    <li class="total">
                        <p>Driveout Price</p>
                        <p class="text-right" title="Total Sale Price + TT & L">{{driveOutPrice | currency}}</p>
                    </li>
                    @if (!wholesale) {
                        <li>
                            <p>PLUS: Trade Payoff</p>
                            <p class="text-right" title="Total of all trade payoffs">{{payoff | currency}}</p>
                        </li>
                    }
                    <li class="clickable" (click)="setActiveTab($event, 'sale-downs-deposits')">
                        <p>
                            @if (termable) {
                                <span>LESS: Down Payments</span>
                            }
                            @if (!termable) {
                                <span>LESS: Deposits</span>
                            }
                        </p>
                        <p class="text-right" title="Total of all down payments">{{down | currency}}</p>
                    </li>
                    <li class="total">
                        @if (termable) {
                            <p>Amount to Finance</p>
                        }
                        @if (!termable) {
                            <p>Amount to Pay</p>
                        }
                        <p class="text-right" title="Driveout Price + Payoff - Down Payments">{{financed | currency}}</p>
                    </li>
                </ul>
            </div>
        </div>
    </section>

    <section class="tab-pane fade" id="sale-downs-deposits-tab">
        <payments-terms [saleId]="saleId" [stage]="isQuote ? 'Quote' : 'Sale'" [saleType]="saleType" [sold]="sold" [isUnLock]="isUnLock"></payments-terms>
    </section>

    <section class="tab-pane fade" id="sale-products-tab">
        <products [saleId]="saleId" [isUnLock]="isUnLock"></products>
    </section>

    <section class="tab-pane fade" id="sale-accessories-tab">
        <accessories [saleId]="saleId" [isUnLock]="isUnLock"></accessories>
    </section>

    <section class="tab-pane fade" id="sale-ttl-tab">
        <ttl [saleId]="saleId" [saleType]="saleType" [isUnLock]="isUnLock"></ttl>
    </section>
</div>

<!--  edit row  -->
<div class="modal fade" id="addEditPackage" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-dialog-centered modal-full-width modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header pb-0">
                <div class="text-dark w-100 modal-title text-center">
                    <h4>Products</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" id="close-modal-communications">×</button>
            </div>
            <div class="modal-body overflow-auto d-flex justify-content-center">
                <div class="row">
                    <div class="col-md-3">
                        <div class="card border-success border">
                            <div class="card-body">
                                <h5 class="card-title">LIMITED WARRANTIES</h5>
                                <!-- <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> -->
                                <form class="form-horizontal">
                                    <div class="row mb-1">
                                        <label for="example-select" class="col-4 col-form-label">Vendor</label>
                                        <div class="col-8">
                                            <select class="form-control form-control-sm text-dark" id="example-select">
                                                <option>AutoAction</option>
                                                <option>BankOne</option>
                                                <option>Burrel Printing</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <label for="example-text" class="col-4 col-form-label">Cost</label>
                                        <div class="col-8">
                                            <input class="form-control form-control-sm" type="number">
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <label for="example-text" class="col-4 col-form-label">Price</label>
                                        <div class="col-8">
                                            <input class="form-control form-control-sm" type="number">
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="card-footer">
                                <a href="javascript: void(0);" class="btn btn-success btn-sm">Add to Sale</a>
                                <a href="javascript: void(0);" class="btn btn-danger btn-sm">Remove from Sale</a>
                            </div>
                        </div> <!-- end card-->
                    </div>
                    <div class="col-md-3">
                        <div class="card border-success border">
                            <div class="card-body">
                                <h5 class="card-title">GUARANTEED ASSET PROTECTION (GAP) INSURANCE</h5>
                                <!-- <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> -->
                                <form class="form-horizontal">
                                    <div class="row mb-1">
                                        <label for="example-select" class="col-4 col-form-label">Vendor</label>
                                        <div class="col-8">
                                            <select class="form-control form-control-sm text-dark" id="example-select">
                                                <option>AutoAction</option>
                                                <option>BankOne</option>
                                                <option>Burrel Printing</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <label for="example-text" class="col-4 col-form-label">Premium</label>
                                        <div class="col-8">
                                            <input class="form-control form-control-sm" type="number">
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <label for="example-text" class="col-4 col-form-label">Cost</label>
                                        <div class="col-8">
                                            <input class="form-control form-control-sm" type="number">
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="card-footer">
                                <a href="javascript: void(0);" class="btn btn-success btn-sm">Add to Sale</a>
                                <a href="javascript: void(0);" class="btn btn-danger btn-sm">Remove from Sale</a>
                            </div>
                        </div> <!-- end card-->
                    </div>
                    <div class="col-md-3">
                        <div class="card border-success border">
                            <div class="card-body">
                                <h5 class="card-title">DEBT CANCELLATION CONTRACT (DCC)</h5>
                                <!-- <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> -->
                                <form class="form-horizontal">
                                    <div class="row mb-1">
                                        <label for="example-select" class="col-4 col-form-label">Vendor</label>
                                        <div class="col-8">
                                            <select class="form-control form-control-sm text-dark" id="example-select">
                                                <option>AutoAction</option>
                                                <option>BankOne</option>
                                                <option>Burrel Printing</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <label for="example-text" class="col-4 col-form-label">Cost</label>
                                        <div class="col-8">
                                            <input class="form-control form-control-sm" type="number">
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="card-footer">
                                <a href="javascript: void(0);" class="btn btn-success btn-sm">Add to Sale</a>
                                <a href="javascript: void(0);" class="btn btn-danger btn-sm">Remove from Sale</a>
                            </div>
                        </div> <!-- end card-->
                    </div>
                    <div class="col-md-3">
                        <div class="card border-success border">
                            <div class="card-body">
                                <h5 class="card-title">CREDIT LIFE / DISABILITY</h5>
                                <!-- <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> -->
                                <form class="form-horizontal">
                                    <div class="row mb-1">
                                        <label for="example-select" class="col-4 col-form-label">Vendor</label>
                                        <div class="col-8">
                                            <select class="form-control form-control-sm text-dark" id="example-select">
                                                <option>AutoAction</option>
                                                <option>BankOne</option>
                                                <option>Burrel Printing</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <label for="example-text" class="col-4 col-form-label">Cost</label>
                                        <div class="col-8">
                                            <input class="form-control form-control-sm" type="number">
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="card-footer">
                                <a href="javascript: void(0);" class="btn btn-success btn-sm">Add to Sale</a>
                                <a href="javascript: void(0);" class="btn btn-danger btn-sm">Remove from Sale</a>
                            </div>
                        </div> <!-- end card-->
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary">
                    Save</button>
                <!-- cancel button -->
                <button class="btn btn-light" id="btn-cancel" data-dismiss="modal" data-dismiss="modal">Close</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>
<!-- /.modal -->


<!--  edit row  -->
<div class="modal fade" id="viewWarrantyDetails" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header pb-0">
                <div class="text-dark w-100 modal-title text-center">
                    <h4>Warranty Details</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" id="close-modal-communications">×</button>
            </div>
            <div class="modal-body overflow-auto justify-content-center">
                <div class="row">
                    <div class="col-md-6 col-sm-12 my-0">
                        <small for="">Warranty Company</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Cost</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Price</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Warranted Time</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Warranted Miles</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Warranty Deductible</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Parts Percentage</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Labor Percentage</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Warranted Components</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Buyer's Obligation</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Months Term</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Miles Term</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Expiration Date</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Expiration Miles</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">Auto Class</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-3 col-sm-12 my-0">
                        <small for="">In Service Date</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                </div>
                <div>
                    <table class="table table-hover text-dark terms-table">
                        <thead>
                            <th>Apply</th>
                            <th class="border-0">Terms</th>
                            <th class="border-0">Rate</th>
                            <th class="border-0">Description</th>
                        </thead>
                        <tbody class="text-dark">
                            <tr>
                                <td class="border-0">
                                    <div class="form-check">
                                        <input type="radio" id="customRadio1" name="customRadio" class="form-check-input">
                                        <label class="form-check-label" for="customRadio1"></label>
                                    </div>
                                </td>
                                <td class="border-0">5.00</td>
                                <td class="border-0">5%</td>
                                <td class="border-0">3%</td>
                            </tr>
                            <tr>
                                <td class="border-0">
                                    <div class="form-check">
                                        <input type="radio" id="customRadio1" name="customRadio" class="form-check-input">
                                        <label class="form-check-label" for="customRadio1"></label>
                                    </div>
                                </td>
                                <td class="border-0">5.00</td>
                                <td class="border-0">5%</td>
                                <td class="border-0">3%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary">
                    Save</button>
                <!-- cancel button -->
                <button class="btn btn-light" id="btn-cancel" data-dismiss="modal" data-dismiss="modal">Close</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<!--  edit row  -->
<div class="modal fade" id="viewGAPDetails" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header pb-0">
                <div class="text-dark w-100 modal-title text-center">
                    <h4>GAP Details</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" id="close-modal-communications">×</button>
            </div>
            <div class="modal-body overflow-auto justify-content-center">
                <div class="row">
                    <div class="col-md-12">
                        <small for="GAPCompanyName">Company Name</small>
                        <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                                <option>GAP 1</option>
                                <option>GAP 2</option>
                                <option>GAP 3</option>
                                <option>GAP 4</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12 my-0">
                        <small for="">Asset Protection Option</small>
                        <div class="form-check form-check-inline"><br>
                            <input type="radio" id="customRadio3" name="customRadio1" class="form-check-input">
                            <label class="form-check-label text-nowrap" for="customRadio3">GAP Insurance Policy</label>
                            <input type="radio" id="customRadio4" name="customRadio1" class="form-check-input ml-1">
                            <label class="form-check-label text-nowrap" for="customRadio4">Debt Cancellation
                                Agreement</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 my-0">
                        <small for="">Cost</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                    <div class="col-md-6 col-sm-12 my-0">
                        <small for="">Premium</small>
                        <input class="form-control form-control-sm text-dark" type="number" autocomplete="off">
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary">
                    Save</button>
                <!-- cancel button -->
                <button class="btn btn-light" id="btn-cancel" data-dismiss="modal" data-dismiss="modal">Close</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<!--  edit row  -->
<div class="modal fade" id="TxDMV" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-dialog-centered modal-full-width modal-dialog-scrollable">
        <div class="modal-content">
            @if (txdmv.header) {
            <div class="modal-header pb-0">
                <div class="text-dark modal-title row w-100">
                    <div class="col-md-4">
                        <p class="m-0 p-0 text-uppercase">Buyer: {{txdmv['header'].buyer}}</p>
                        <p class="m-0 p-0 text-uppercase">Vehicle: {{txdmv['header'].vehicle}}</p>
                        <p class="m-0 p-0 text-uppercase">VIN: {{txdmv['header'].vin}}</p>
                        <p class="m-0 p-0 text-uppercase">Stock #: {{txdmv['header'].stock}}</p>
                    </div>
                    <div class="col-md-4 text-center">
                        <h4>TxDMV webDEALER & eTag</h4>
                    </div>
                    <div class="col-md-4 text-right">
                        <p class="m-0 p-0">Title ID:
                            @if (txdmv.body.length>0) {
                            <span>
                                {{txdmv.body[txdmv.body.length-1].message['ax21:titleId'] }}
                            </span>
                            }
                        </p>
                        <p class="m-0 p-0">Latest Title Application Status: @if (txdmv.body.length>0) {
                            <span>{{txdmv.body[txdmv.body.length-1].message['ax21:success']=='true'?'Success':'Failed'
                                }}</span>
                            }
                        </p>
                        <!-- <p class="m-0 p-0">Title Application Last Update Date: 12/01/2021</p> -->
                        <p class="m-0 p-0">eTag Number: {{txdmv['header'].etagNumber}}</p>
                        <!-- <p class="m-0 p-0">eTag Creation Date: 12/01/2021</p> -->
                    </div>
                </div>
                <!-- <button type="button" class="close" data-dismiss="modal"
id="close-modal-communications">×</button> -->
            </div>
            }
            <div class="modal-body overflow-auto d-flex">
                <div>
                    <h5 class="mb-0">Transaction History</h5>
                    <table class="table text-dark">
                        <thead>
                            <th class="p-0">Timestamp</th>
                            <th class="p-0">webDEALER Username</th>
                            <th class="p-0">Username</th>
                            <th class="p-0">Action</th>
                            <th class="p-0">Message</th>
                        </thead>
                        <tbody>
                            @for (object of txdmv.body; track object) {
                            <tr>
                                <td>{{object.createdAt | date:'short'}}</td>
                                <td>{{object.username}}</td>
                                <td>{{object.user.firstName}} {{object.user.lastName}}</td>
                                <td>{{object.action}}</td>
                                <td>
                                    <ul class="list-unstyled">
                                        <!-- object -->
                                        <li>
                                            @if (!object.message['ax21:messages']['xsi:nil']) {
                                            <div>
                                                {{object.message['ax21:messages']['xsi:nil']=='true'?'Message: No
                                                Error':'Message: Error'}}
                                            </div>
                                            }
                                        </li>
                                        <li>
                                            @if (object.message['ax21:messages']['ax21:messageDescription']) {
                                            <div>
                                                {{object.message['ax21:messages']['ax21:messageDescription']}}</div>
                                            }
                                        </li>
                                        @if (object.message['ax21:messages']['length']>0) {
                                        <div>
                                            @for (message of object.message['ax21:messages']; track message) {
                                            <li>
                                                {{message['ax21:messageDescription']}}</li>
                                            }
                                        </div>
                                        }
                                        @for (fee of object.message['ax21:fees']; track fee) {
                                        <li>
                                            {{fee['ax21:feeDescription']}}: {{fee['ax21:feeAmount']}}</li>
                                        }
                                        <li>Status: {{object.message['ax21:success']=='true'?'Success':'Failed'}} </li>
                                        <!-- <div *ngIf="object.message['ax21:fees'].length>0">
</div> -->
                                    </ul>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer d-flex row">
                <div class="mr-auto">
                    <!-- [disabled]="txdmv.body.length>0 && txdmv.body[txdmv.body.length-1].message['ax21:success']=='true'" -->
                    <button class="btn btn-primary mr-1" (click)="uploadTitle()" [disabled]="loading">
                        @if (loading) {
                        <div class="spinner-grow spinner-grow-sm" role="status"></div>
                        }
                        Upload Title Application
                    </button>
                    <!-- [disabled]="!(txdmv.body.length>0 && txdmv.body[txdmv.body.length-1].message['ax21:success']=='true')" -->
                    <button class="btn btn-primary mr-1" (click)="checkTitleTXDMV()" [disabled]="loading">
                        @if (loading) {
                        <div class="spinner-grow spinner-grow-sm" role="status"></div>
                        }
                        Check Title Status
                    </button>
                    <button class="btn btn-primary mr-1" [disabled]="loading">
                        @if (loading) {
                        <div class="spinner-grow spinner-grow-sm" role="status"></div>
                        }
                        Create eTag
                    </button>
                    <button class="btn btn-primary mr-1" [disabled]="loading" (click)="openWebSite()">
                        @if (loading) {
                        <div class="spinner-grow spinner-grow-sm" role="status"></div>
                        }
                        Open TxDMV Website
                    </button>
                </div>
                <!-- cancel button -->
                <button class="btn btn-light" id="btn-cancel" data-dismiss="modal" data-dismiss="modal">Close</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<!-- Warning Alert Modal -->
<button type="button" class="btn btn-outline-warning d-none" data-toggle="modal" data-target="#warning-alert-modal"
    id="btn-warning-saletype">Warning Alert</button>
<div id="warning-alert-modal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body p-4">
                <div class="text-center">
                    <span class="dripicons-warning h1 text-warning"></span>
                    <h4 class="mt-2">Warning</h4>
                    <p class="mt-3">Are you sure you want to change the Sale Type? This will delete all contract
                        information on the sale.</p>
                    <div class="d-flex p-2 d-flex w-100 justify-content-center">
                        <button type="button" class="btn btn-outline-warning m-1" data-dismiss="modal">Continue</button>
                        <button type="button" class="btn btn-outline-secondary m-1" data-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->